import axios from "axios";
import { createApiError } from "./errorUtils";

axios.defaults.withCredentials = true;

const API_URL = process.env.REACT_APP_API_URL;

export function login(email, password) {
  return axios.post(`${API_URL}/auth/login`, { email, password }).catch((error) => {
    throw createApiError(error, "Erro ao se comunicar com o servidor.");
  });
}

export function logout() {
  return axios.post(`${API_URL}/auth/logout`).catch((error) => {
    throw createApiError(error, "Erro ao se comunicar com o servidor.");
  });
}

export function checkAuthStatus() {
  return axios.get(`${API_URL}/auth/status`).catch((error) => {
    throw createApiError(error, "Erro ao verificar o status de autenticação.");
  });
}
